import React from 'react';

export const Description = ({ description }) => (
  <React.Fragment>
    <p><strong>Description de l&apos;activité</strong></p>
    <p>{description}</p>
  </React.Fragment>
);

export default Description;



// WEBPACK FOOTER //
// ./src/components/Summary/Controls/ControlDescription.js